import { HelocConfirmation } from '../../../../containers/Mortgage/HelocDraw';
import HelocDrawPreConfirmationStack from './HelocDrawPreConfirmationStack';

export default {
  HelocConfirmation: { component: HelocConfirmation },
  HelocDrawPreConfirmation: { component: HelocDrawPreConfirmationStack },
};
